import { Component, Vue, PropSync, Emit } from 'vue-property-decorator';
import { DataSetEditor } from '@/models/dataset/DataSetEditor';
import { Helpers } from '@/helpers/Helpers';

import HeaderLogo from '@/components/general/headerlogo/HeaderLogo.vue';
import { DataSetMyMillInformation } from '@/models/dataset/DataSetMyMillInformation';

@Component({
    components: {
        HeaderLogo,
    },
})
export default class HeaderBarComponent extends Vue {
    @PropSync('title', { type: String }) public syncedTitle!: string;
    @PropSync('saveButton', { type: String }) public syncedsaveButton!: string;
    @PropSync('saveButtonActive', { type: Boolean }) public syncedSaveButtonActive!: boolean;
    @PropSync('showSaveButton', { type: Boolean, default: true }) public syncedShowSaveButton!: boolean;
    @PropSync('datasetId', { type: String }) public syncedDatasetId!: string;
    @PropSync('creator', { type: Object }) public syncedCreator!: DataSetEditor;
    @PropSync('editor', { type: Object }) public syncedEditor!: DataSetEditor;
    @PropSync('cancelButton', { type: Boolean }) public namedCancelButton!: boolean;
    @PropSync('myMill', { type: Object }) public syncedMyMill!: DataSetMyMillInformation;

    // tslint:disable-next-line: no-empty
    public mounted() {}

    @Emit()
    public save(): boolean {
        return true;
    }

    @Emit()
    public cancel(): boolean {
        return true;
    }

    @Emit()
    public copyDataSetId(): boolean {
        return true;
    }

    public onCancel() {
        // this.$router.back();
        this.cancel();
    }

    public onSave() {
        this.save();
    }

    public showInfoField(): boolean {
        return this.syncedDatasetId ? true : false;
    }

    public getCreator(): string {
        return this.syncedCreator ? this.getUserDateTimeString(this.syncedCreator, 'created') : '';
    }

    public getEditor(): string {
        return this.syncedEditor ? this.getUserDateTimeString(this.syncedEditor, 'updated') : '';
    }

    public getMyMill(): string {
        let returnString = '';
        if (this.syncedMyMill) {
            const dateString = Helpers.getFormattedDateString(this.syncedMyMill.extractionDate);
            const timeString = Helpers.getFormattedTimeString(this.syncedMyMill.extractionDate, 'en-GB', true);
            returnString = this.$vuetify.lang.t(`$vuetify.headerBar.myMill`, dateString, timeString);
        }

        return returnString;
    }

    private getUserDateTimeString(inDataSetEditor: DataSetEditor, localIdentifier: 'created' | 'updated'): string {
        const dateString = Helpers.getFormattedDateString(inDataSetEditor.date);
        const timeString = Helpers.getFormattedTimeString(inDataSetEditor.date);

        return this.$vuetify.lang.t(`$vuetify.headerBar.${localIdentifier}`, inDataSetEditor.userName, dateString, timeString);
    }
}
